import { Table } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import NoResultsMsg from '../../../components/NoResultsMsg/NoResultsMsg';
import useColumn from '../hooks/useColumn';
import { SelectedClass } from './FutureClassesSearch';

interface Props {
  results: SelectedClass[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
  resultsPerPage: number;
  isLoadingResults: boolean;
  onPageChange: (page: number) => void;
  onClassAdvance: (classData: SelectedClass) => void;
  onClassRecovery: (classData: SelectedClass) => void;
  onClassChangeClassroom: (classData: SelectedClass) => void;
}

export default function FutureClassesTable({
  results,
  currentPage,
  totalPages,
  totalItems,
  resultsPerPage,
  isLoadingResults,
  onPageChange,
  onClassAdvance,
  onClassRecovery,
  onClassChangeClassroom,
}: Props) {
  const { t } = useTranslation();
  const columns = useColumn({
    onClassAdvance,
    onClassRecovery,
    onClassChangeClassroom,
  });

  return (
    <div className="text-center">
      <Table
        noResultsText={<NoResultsMsg />}
        columns={columns}
        data={results}
        pagination={
          totalPages > 1
            ? {
                totalItems,
                totalPages,
                currentPage: currentPage + 1,
                itemsPerPage: resultsPerPage,
                onChangePage: (page) => onPageChange(page - 1),
              }
            : undefined
        }
        isLoadingResults={isLoadingResults}
        loadingView={{
          title: t(`startClasses.loadingTitles.title`),
          subtitle: t(`startClasses.loadingTitles.subtitle`),
        }}
      />
    </div>
  );
}
